// | ------------------------------------------------------------------------
// | GSAP Scroll Animations - Feedback Background
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// | ------------------------------------------------------------------------

//Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// | ------------------------------------------------------------------------

// var abstractSection = document.querySelector(".animated-abstract-section");

function abstractBg(showMarkers, abstractSection) {

  var abstractImg1 = abstractSection.querySelector(".abstract-1");
  var abstractImg2 = abstractSection.querySelector(".abstract-2");
  var abstractImg3 = abstractSection.querySelector(".abstract-3");
  var abstractContent = abstractSection.querySelector(".abstract-content");

  const animateAbstractBg = gsap.timeline({
    paused: "true",
    scrollTrigger: {
      trigger: abstractContent,
      start: "-=500px",
      end: "bottom",
      scrub: true,
      markers: showMarkers,
      id: "abstract-bg",

    },
  });

  gsap.set(abstractImg1, {
    position: "absolute",
    scale: 0.6,
    left: "-15%",
    bottom: "60%",
    filter: "blur(15px)",
    opacity: ".5",
    rotation: -180,
  });

  animateAbstractBg.to(
    abstractImg1,
    {
      scale: 0.7,
      left: "-8%",
      bottom: "50%",
      filter: "blur(4px)",
      opacity: ".7",
      duration: 300,
      ease: "power2.out",
    },
    0
  );

  gsap.set(abstractImg2, {
    position: "absolute",
    scale: 1.3,
    left: "50%",
    top: "10%",
    filter: "blur(20px)",
    opacity: ".5",
  });

  animateAbstractBg.to(
    abstractImg2,
    {
      scale: 0.85,
      left: "60%",
      top: "15%",
      filter: "blur(10px)",
      opacity: ".7",
      duration: 300,
      ease: "power4.out",
    },
    0
  );

  gsap.set(abstractImg3, {
    position: "absolute",
    scale: 0.7,
    right: "-15%",
    bottom: "60%",
    filter: "blur(0px)",
    opacity: "1",
    rotation: -110,
  });

  animateAbstractBg.to(
    abstractImg3,
    {
      scale: 0.5,
      right: "-5%",
      bottom: "50%",
      filter: "blur(10px)",
      opacity: ".8",
      duration: 300,
    },
    0
  );
}

export {abstractBg};
